import { registerLocale, setDefaultLocale } from 'react-datepicker';

const loadedLocales = {
  en: true,
};
const localizeDatePicker = (locale) => {
  if (loadedLocales[locale]) {
    setDefaultLocale(locale);
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    /* eslint-disable */
     import(
       /* webpackInclude: /(tr|de|fr)/index.js$/ */
       /* webpackChunkName: "date-fns-locale-" */
       /* webpackMode: "lazy" */
       /* webpackPrefetch: false */
       /* webpackPreload: false */
       'date-fns/locale/' + locale + '/index.js'
     )
    /* eslint-enable */
       .then((newLocale) => {
         registerLocale(locale, newLocale);
         setDefaultLocale(locale);
         loadedLocales[locale] = true;
         resolve();
       }).catch(err => reject(err));
  });
};

export default localizeDatePicker;
